import reducer from './reducer'
import * as selectors from './selectors'

export default reducer
export const { openModal, closeModal } = reducer.actions
export { selectors }
